const URLBOX_ELEMENT_SELECTOR_ID = 'visualization-container';

export { URLBOX_ELEMENT_SELECTOR_ID };
